import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VehiculoPasoPunto } from './../../../_entities/paso-punto/vehiculo-paso-punto';
import { environment } from './../../../../environments/environment';
import { PuntoInteres } from './../../../_entities/puntos-interes/puntoInteres';
import { ProductosPunto } from './../../../_entities/paso-punto/productos-punto';

@Injectable({
	providedIn: 'root'
})
export class PasoPuntoService {

	constructor(private http: HttpClient) { }

	obtenerPasoPunto(idPunto, fechaInicio, fechaFinal): Observable<VehiculoPasoPunto[]> {
		return this.http.get<VehiculoPasoPunto[]>(`${environment.API_SECURITY}/api/PuntosInteres/${idPunto}/paso-por-punto`, {
			params: {
				fechaInicio,
				fechaFinal
			}
		})
	}

	obtenerPasoPuntoVehiculo(formPuntos, fechaInicio, fechaFinal): Observable<VehiculoPasoPunto[]> {
		return this.http.post<VehiculoPasoPunto[]>(`${environment.API_SECURITY}/api/PuntosInteres/paso-por-punto`, formPuntos, {
			params: {
				fechaInicio,
				fechaFinal
			}
		})
	}

	obtenerPasoPuntoVehiculos(ids, fechaInicio, fechaFinal): Observable<VehiculoPasoPunto[]> {
		return this.http.post<VehiculoPasoPunto[]>(`${environment.API_SECURITY}/api/PuntosInteres/paso-por-punto`, ids, {
			params: {
				fechaInicio,
				fechaFinal
			}
		})
	}

	obtenerPuntosInteres(): Observable<PuntoInteres[]> {
		return this.http.get<PuntoInteres[]>(`${environment.API_SECURITY}/api/puntosinteres`);
	}

	obtenerProductos(): Observable<ProductosPunto[]>{
		return this.http.get<ProductosPunto[]>(environment.API_SECURITY + '/api/PuntosInteres/ListaInstalacionPuntos');
	}


}
